import { Component, OnInit, OnDestroy } from "@angular/core";
import { ThemeService } from "../../theme.service";

@Component({
  selector: "app-only-header-layout",
  templateUrl: "./only-header-layout.component.html",
  styleUrls: ["./only-header-layout.component.scss"]
})
export class OnlyHeaderLayoutComponent implements OnInit, OnDestroy {
  disablePadding = false;

  constructor(private themeService: ThemeService) {
  }

  ngOnInit() {
    this.themeService.animationState = "out";
    this.themeService.disableMenuOpen.emit();
  }

  ngOnDestroy() {
    this.themeService.animationState = "in";
    this.themeService.enableMenuOpen.emit();
  }

  get isOpen() {
    return this.themeService.animationState;
  }
}
